import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'brDataFormat'
})

export class DataFormatPipe implements PipeTransform {
    
    transform(valor: string, tipo: string): string {
        if (!valor) return '';

        switch (tipo) {
            case 'cpfCnpj':
                if (valor.length <= 11) {
                    return valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
                } else {
                    return valor.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                        '$1.$2.$3/$4-$5'
                    );
                }
            case 'telefone':
                if (valor.length === 10) {
                    return valor.replace(/^(\d{2})(\d{4})(\d{4})$/, '$1$2-$3');
                } else if (valor.length === 11) {
                    return valor.replace(/^(\d{2})(\d{5})(\d{4})$/, '$1$2-$3');
                } else {
                    return valor;
                }
            default:
                return valor;
        }
    }
}
